import React from 'react'
import { Row, Container, Button } from 'reactstrap';
import { showErrorPage, updateCrqPage } from '../services/historyWrapper';
import { FaSpinner } from 'react-icons/fa';
import './Loader.scss';
import axios, { AxiosError } from 'axios';
import errorResponseHandler from '../services/errorHandling';
import { getBaseUrl, getQueryStringPage } from '../services/helper';
import { ApplicationState } from '../store';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { isNil } from 'lodash';
import { ErrorLog, logError } from '../services/logger';
import connect from 'react-redux/es/components/connect';
import { ThunkDispatch } from 'redux-thunk';
import { Coverages, Driver, HomeCharacteristics, homeownersType, LineOfBusinessType } from '../store/Quote/state';
import { Action as QuoteAction, actionCreators as QuoteActions } from '../store/Quote/actions';
import { actionCreators as StepperActions } from '../store/Stepper/actions';
import { Vehicle } from '../store/Quote/Vehicle/vehicle';
import { StepType } from '../store/Stepper/state';

type WaitPageProps =
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class WaitPage extends React.PureComponent<WaitPageProps, null> {
  connection: HubConnection | null;
  retryAttempts: number = 3;
  hasVerifiedLob: boolean = false;

  constructor(props: any) {
    super(props);

    this.connection = null;
  }

  componentDidMount() {
    this.connectSignalRConnection();
    setTimeout(() => {
      if (getQueryStringPage(window.location) === 'waitpage') {
        updateCrqPage('driverpage')
      }
    }, 60000);
  }

  componentWillUnmount() {
    this.stopSignalRConnection();
  }

  startSignalRConnection(startFunc: Function | null = null) {
    if (!isNil(this.connection)) {
      this.connection.start()
        .then(() => {
          if (startFunc !== null) {
            startFunc();
          }
        })
        .catch((err: any) => {
          console.error('SignalR Connection Error: ', err);

          if (this.retryAttempts > 0) {
            this.retryAttempts--;
            console.log(`retrying the connnection ${3 - this.retryAttempts} of 3`);

            // stop (reset) the existing connection, wait 3 secords and try again
            this.stopSignalRConnection()
              .then(() => new Promise(r => setTimeout(r, 3000)))
              .then(() => {
                this.connectSignalRConnection();
              });
          }
          else {
            const data: ErrorLog = {
              ExceptionMessage: 'SignalR Connection Error',
              Details: err.toString()
            };

            logError(data).then(value => {
              showErrorPage(value);
            });
          }
        });
    }
  };

  stopSignalRConnection() {
    if (!isNil(this.connection)) {
      // clear to prevent restart on disconnect logic from firing
      let connection: HubConnection = this.connection;
      this.connection = null;
      return connection.stop();
    }
    else {
      return Promise.resolve();
    }
  };

  connectSignalRConnection() {
    let lookupKey = "";
    if (this.props.site.apiRequestImportKey !== undefined) {
      lookupKey = this.props.site.apiRequestImportKey;
    }

    if (lookupKey != null) {
      this.connection = new HubConnectionBuilder()
        .withUrl(`${getBaseUrl()}/apiRequestImportHub?lookupKey=${lookupKey}`)
        .build();

      this.connection.on('getData', (importedQuote: any) => {
        //save object client side
        this.props.prefillQuote(importedQuote.isPersonalAuto, importedQuote.homeowners, importedQuote.lineOfBusiness, importedQuote.fullAddress,
          importedQuote.addressState, importedQuote.addressLine1, importedQuote.addressLine2, importedQuote.city, importedQuote.zip,
          importedQuote.addressVerified, importedQuote.agencyLicense, importedQuote.drivers, importedQuote.vehicles, importedQuote.homeCharacteristics,
          importedQuote.coverages, importedQuote.quoteId, lookupKey, importedQuote.maxExceededDriversOnImport, importedQuote.maxExceededVehiclesOnImport,
          importedQuote.maxExceededLossesOnImport, importedQuote.maxExceededIncidentsOnImport, importedQuote.invalidVinOnImport);


        this.stopSignalRConnection();
        this.props.changeStep(StepType.None, StepType.ApplicantDrivers);
      });

      this.connection.on('showError', (refId: string) => {
        this.stopSignalRConnection();
        showErrorPage(refId);
      });

      this.connection.on('invalidLob', () => {
        this.stopSignalRConnection()
          .then(() => {
            if (!this.hasVerifiedLob) {
              this.props.updateImportFailure(true);
              this.props.changeStep(StepType.None, StepType.ApplicantDrivers);
              this.hasVerifiedLob = true;
            }
          });
      });

      this.connection.on('closeConnection', () => {
        this.stopSignalRConnection();
      });

      // re-establish the connection if connection dropped
      this.connection.onclose(() => setTimeout(this.startSignalRConnection, 5000));

      // start
      this.startSignalRConnection(() => {
        axios.get(`${getBaseUrl()}/APIRequestImport/SignalR/${this.props.quote.quoteId}/${lookupKey}/${this.props.quote.lineOfBusiness}/${this.props.site.id}`) 
          .then((response) => {
            if (response.status !== 200) {
              this.stopSignalRConnection();
            }
          })
          .catch((error: AxiosError) => {
            errorResponseHandler(error);
          });
      });
    }
  };

  render() {
    return (
      <Container>
        <Row className='d-flex align-items-center justify-content-center min-vh-50 w-100 mt-5 pt-5'>
          <div className="d-flex justify-content-center align-items-center h-100">
            <FaSpinner className="spin" />
            <div className="ml-2">
              Fetching Data...
            </div>
          </div>
        </Row>
        <Row>
          <div className='d-flex align-items-center justify-content-center min-vh-50 w-100 mt-5'>
            <Button color='previous' className={'mr-1 mr-md-3'} onClick={() => updateCrqPage('driverpage')}>Cancel</Button>
          </div>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  site: state.site,
  quote: state.quote
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, QuoteAction>) => ({
  prefillQuote: (isPersonalAuto: boolean, homeowners: homeownersType, lineOfBusiness: LineOfBusinessType, fullAddress: string, addressState: string, addressLine1: string,
    addressLine2: string, city: string, zip: string, addressVerified: boolean, agencyLicense: string, drivers: Driver[], vehicles: Vehicle[],
    homeCharacteristics: HomeCharacteristics, coverages: Coverages, quoteId: string, apiRequestImportKey: string | null, maxExceededDriversOnImport: boolean,
    maxExceededVehiclesOnImport: boolean, maxExceededLossesOnImport: boolean, maxExceededIncidentsOnImport: Record<number, boolean>,
    invalidVinOnImport: Record<number, boolean>) =>
    dispatch(QuoteActions.prefillQuote(isPersonalAuto, homeowners, lineOfBusiness, fullAddress, addressState, addressLine1, addressLine2, city,
      zip, addressVerified, agencyLicense, drivers, vehicles, homeCharacteristics, coverages, quoteId, apiRequestImportKey, maxExceededDriversOnImport,
      maxExceededVehiclesOnImport, maxExceededLossesOnImport, maxExceededIncidentsOnImport, invalidVinOnImport)),
  changeStep: (current: StepType, selected: StepType) => dispatch(StepperActions.changeStep(current, selected)),
  updateImportFailure: (importApiFailure: boolean) => dispatch(QuoteActions.updateImportFailure(importApiFailure)),
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(WaitPage as any);